import { createSelector } from 'reselect'

import { getEntity, getListState } from 'data'

import { getActiveOrganizationId } from 'data/ui/selectors'

import { OrganizationsPermissions } from './record'

export const INTEGRATIONS_LIST_NAME = 'organizationIntegrationsList'

export const getOrganizationId = getActiveOrganizationId

export const getOrganization = (state, organizationId) => {
  const id = organizationId || getOrganizationId(state)
  return (
    getEntity(state, 'Organization', id) ||
    getEntity(state, 'OrganizationPublic', id)
  )
}

export const getOrganizationFetchError = state => state.organizations.error

export const getJoinedOrganizations = state =>
  state.organizations.joined.filter(organization => !!organization)

export const membersCanInvite = state =>
  getOrganization(state).get('membersCanInvite')

export const membersCanAutoJoin = state =>
  getOrganization(state).get('membersCanAutoJoin')

export const getUpdateOrganizationPhotoState = state =>
  state.organizations.get('updateOrganizationPhoto')

export const getFeatureFlags = state => {
  const organization = getOrganization(state)
  if (!organization) {
    return ''
  }
  return organization.get('featureFlags') || ''
}

export const getOrganizationPermissions = state => {
  const organization = getOrganization(state)
  if (!organization || !organization.permissions) {
    return OrganizationsPermissions()
  }
  return organization.permissions
}

export const getInviteToken = state => getOrganization(state).get('inviteToken')

export const hasFeatureFlag = (state, flag) =>
  getFeatureFlags(state)
    .split(/[,\s]+/)
    .includes(flag)

export const hasSSOEnabled = state => {
  return getOrganization(state).get('authMethod') !== 'emailPassword'
}

export const isFree = state => {
  const organization = getOrganization(state)
  if (!organization) {
    return true
  }
  return organization.product === 'free'
}

export const isPaid = state => {
  return !isFree(state)
}

export function getAllIntegrationsListState(state) {
  return getListState(INTEGRATIONS_LIST_NAME)(state)
}

export const getAllIntegrations = state =>
  getAllIntegrationsListState(state).edges

export const getAllIntegratedApplications = createSelector(
  getAllIntegrations,
  allIntegrations => {
    return allIntegrations.map(edge => edge.node.application)
  }
)
